import React from 'react';
import ThumbnailContainer from "../thumbnail/ThumbnailContainer";
import QuestionNavContainer from "../nav/QuestionNavContainer";
import './SolutionGrid.scss';

const SolutionGrid = props => {
  const {questions, currentQuestion, choices, goToQuestion} = props;

  let thumbnails = [];
  for(let i = 0; i < questions.length; i++) {
    let q = questions[i];
    let isSelected = currentQuestion === i;
    let isValid = (choices.length > 0) ? choices[i].valid : null;
    thumbnails.push(<ThumbnailContainer key={q.id} image={q.image} valid={isValid} selected={isSelected} onClick={() => goToQuestion(i)}/>)
  }

  return (
    <section className="solution__grid-container">
      {currentQuestion != null ? <QuestionNavContainer/> : null}
      <div className="solution__grid">
        {thumbnails}
      </div>
    </section>
  );
};

export default SolutionGrid;
